import styled from '@emotion/styled';
import React from 'react';
import { sronly } from '../../styles/mixins';

interface IProps {
  title: string;
  target: string;
  children: React.ReactNode;
}

const Host = styled.a`
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const SrOnly = styled.span`
  ${sronly}
`;

export const SvgButton = ({ title, children, target, ...rest }: IProps) => {
  return (
    <Host target={target} title={title} {...rest}>
      {children}
      <SrOnly>{title}</SrOnly>
    </Host>
  );
};
